import type { ReactNode } from "react";
import type { ActionMenuItem } from "@/app/components/ActionMenu";
import EnquiryTable, { EnquiryData, EnqSortCol, PrimaryAction } from "./EnquiryTable";
import EnquiryCard from "./EnquiryCard";

interface EnquiryListProps {
  enquiries: EnquiryData[];
  /** Opens the enquiry's details popup (row / card click) */
  onOpen: (id: number) => void;
  primaryAction: (e: EnquiryData) => PrimaryAction | null;
  menuItems: (e: EnquiryData) => ActionMenuItem[];
  emptyState: ReactNode;
  sortCol?: EnqSortCol | null;
  sortDir?: "asc" | "desc";
  onSort?: (col: EnqSortCol) => void;
}

export default function EnquiryList({
  enquiries,
  onOpen,
  primaryAction,
  menuItems,
  emptyState,
  sortCol,
  sortDir,
  onSort,
}: EnquiryListProps) {
  return (
    <>
      {/* Desktop Table */}
      <EnquiryTable
        enquiries={enquiries}
        onOpen={onOpen}
        primaryAction={primaryAction}
        menuItems={menuItems}
        emptyState={emptyState}
        sortCol={sortCol}
        sortDir={sortDir}
        onSort={onSort}
      />

      {/* Mobile Cards */}
      <EnquiryCard
        enquiries={enquiries}
        onOpen={onOpen}
        primaryAction={primaryAction}
        menuItems={menuItems}
        emptyState={emptyState}
      />
    </>
  );
}
